import { Link } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth/useAuth';
import { ThemeToggle } from './ThemeToggle';
import { NAV_LINKS } from './navConfig';

export function MobileMenu({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { isAuthenticated } = useAuth();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="left-auto right-4 top-4 max-w-xs translate-x-0 translate-y-0">
        <DialogTitle className="sr-only">Menu</DialogTitle>
        <nav className="mt-2 flex flex-col gap-1" aria-label="Mobile">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={onClose}
              className="rounded-lg px-3 py-2.5 text-base font-medium text-ink hover:bg-surface-2"
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="mt-4 grid grid-cols-1 gap-2 border-t border-line pt-4">
          <Button asChild variant="ghost" onClick={onClose}>
            <Link to="/get-help">Get Help</Link>
          </Button>
          <Button asChild variant="outline" onClick={onClose}>
            <Link to="/join">Join Us</Link>
          </Button>
          <Button asChild variant="secondary" onClick={onClose}>
            <Link to="/donate">Donate</Link>
          </Button>
          {!isAuthenticated && (
            <Button asChild variant="link" onClick={onClose}>
              <Link to="/login">Sign in</Link>
            </Button>
          )}
          <div className="flex items-center justify-between px-1 pt-2">
            <span className="text-sm text-muted">Theme</span>
            <ThemeToggle />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
